export { default as MyAccountPageTiles } from './MyAccountPageTiles';
